import { render, staticRenderFns } from "./ManageCourseCategories.vue?vue&type=template&id=e8ee8382"
import script from "./ManageCourseCategories.vue?vue&type=script&lang=js"
export * from "./ManageCourseCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports